import React from "react";
import EventList from "../../components/event/EventList";

const EventsPage = () => {
    return <EventList/>
}

export default EventsPage;